<template>
  <span class="app-spinner"
        role="status"
        :aria-label="label"
        :style="{ width: `${size}px`, height: `${size}px` }"></span>
</template>

<script>
// The shell's spinner: a thin Talk blue ring that turns once every 0.7 seconds
export default {
  name: 'app-spinner',

  props: {
    size: {
      type: Number,
      default: 24
    },

    label: {
      type: String,
      default: 'Loading'
    }
  }
}
</script>

<style lang="scss">
@import 'src/css/shell-tokens';

.app-spinner {
  display: inline-block;
  flex: none;
  border: 2px solid shell-alpha($shell-color-accent, 0.2);
  border-top-color: $shell-color-accent;
  border-radius: 50%;
  animation: app-spinner-turn 700ms linear infinite;
}

@keyframes app-spinner-turn {
  to {
    transform: rotate(360deg);
  }
}

// Progress still needs to show, so the ring keeps turning, slower
@media (prefers-reduced-motion: reduce) {
  .app-spinner {
    animation-duration: 1.6s;
  }
}
</style>
